import * as React from "react";
import {
    List as ReactAdminList,
    Datagrid,
    EmailField,
    DateField
} from "react-admin";
import {
    CancelDeletionRequestButton
} from "../../components/buttons/CancelDeletionRequestButton";

export const List: React.FC = () => {

    return (
        <ReactAdminList
            title="Pending Requests for Account Deletion"
            sort={{ field: "InsertedAt", order: "DESC" }}
        >
            <Datagrid rowClick="edit" isRowSelectable={() => false} bulkActionButtons={false}>
                <EmailField source="Email" />
                <DateField source="InsertedAt" label="Date Requested" />
                <CancelDeletionRequestButton />
            </Datagrid>
        </ReactAdminList>
    );
};
